module.exports = __webpack_public_path__ + "img/vivo-1.641a637f.png";